<template>
  <div>
    <el-menu class="navbar" mode="horizontal">
      <hamburger
        :toggle-click="toggleSideBar"
        :is-active="sidebar.opened"
        class="hamburger-container"
      />
      <breadcrumb />
      <div class="right-menu">
        <el-dropdown
          class="userinfo-container right-menu-item"
          trigger="click"
          @command="handleCommand"
        >
          <div class="username-wrapper">
            <span class="">{{ username }}</span>
            <i class="el-icon-caret-bottom" />
          </div>
          <el-dropdown-menu slot="dropdown" class="user-dropdown">
            <el-dropdown-item command="dashboard" style="text-align: center;"
              >主页</el-dropdown-item
            >
            <el-dropdown-item divided command="resetPwd">
              <span style="display:block;">修改密码</span>
            </el-dropdown-item>
            <el-dropdown-item divided command="logout">
              <span style="display:block;">退出登录</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-menu>
    <el-dialog
      title="修改密码"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="35%"
    >
      <el-form
        :model="pwdForm"
        ref="pwdForm"
        :rules="pwdFormRules"
        label-width="80px"
      >
        <el-form-item label="当前密码" prop="currentPwd">
          <el-input
            type="password"
            v-model="pwdForm.currentPwd"
            autocomplete="off"
            placeholder="请输入当前密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="pwd1">
          <el-input
            type="password"
            v-model="pwdForm.pwd1"
            autocomplete="new-password"
            placeholder="请输入新密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="pwd2">
          <el-input
            type="password"
            v-model="pwdForm.pwd2"
            autocomplete="new-password"
            placeholder="再次输入新密码"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="saveNewPassword"
          v-loading="saveLodingState"
          >确认修改</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import { logout, updateCurrentPassword } from "../../../api/auth";

export default {
  data: function() {
    const validateNewPassword = (rule, value, callback) => {
      if (value != null && value != "") {
        if (this.pwdForm.pwd1 !== this.pwdForm.pwd2) {
          callback(new Error("两次输入密码不一致"));
        } else {
          callback();
        }
      } else {
        callback(new Error("确认密码不能为空"));
      }
    };
    return {
      pwdForm: {
        currentPwd: null,
        pwd1: null,
        pwd2: null
      },
      pwdFormRules: {
        currentPwd: [
          { required: true, message: "当前密码不能为空", trigger: "blur" }
        ],
        pwd1: [{ required: true, message: "新密码不能为空", trigger: "blur" }],
        pwd2: [{ validator: validateNewPassword, trigger: "blur" }]
      },
      dialogFormVisible: false,
      saveLodingState: false
    };
  },
  components: {
    Breadcrumb,
    Hamburger
  },
  computed: {
    ...mapGetters(["sidebar", "username"])
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("ToggleSideBar");
    },
    handleCommand(command) {
      if (command == "dashboard") {
        var currentPath = this.$router.currentRoute.path.replace("/", "");
        if (currentPath == "dashboard") {
          console.log("visitedViews", this.$store.state.tagsView.visitedViews);
          var visitedViews = this.$store.state.tagsView.visitedViews;
          if (!visitedViews || visitedViews.length == 0) {
            this.$router.go(0);
          } else {
            this.$router.push({ path: "/dashboard" });
          }
        } else {
          this.$router.push({ path: "/dashboard" });
        }
      } else if (command == "logout") {
        this.logoutHandler();
      } else if (command == "resetPwd") {
        //修改密码，首先清空form
        this.pwdForm.currentPwd = null;
        this.pwdForm.pwd1 = null;
        this.pwdForm.pwd2 = null;
        this.dialogFormVisible = true;
      }
    },
    logoutHandler() {
      //let self = this;
      let store = this.$store;
      logout()
        .then()
        .finally(() => {
          this.$store.dispatch("clearAccessInfo").then(() => {
            store.dispatch("clearRoutes").then(() => {
              setTimeout(function() {
                window.location.href = process.env.BASE_URL + "login";
                //self.$router.push("/login");
              }, 500);
            });
          });
        });
    },
    saveNewPassword: function() {
      let self = this;
      //保存新密码
      this.$refs["pwdForm"].validate(valid => {
        if (valid) {
          self.saveLodingState = true;
          updateCurrentPassword(self.pwdForm.currentPwd, self.pwdForm.pwd2)
            .then(res => {
              if (res.code === "200") {
                this.$message.success("修改成功！");
                self.dialogFormVisible = false;
              }
            })
            .finally(() => {
              self.saveLodingState = false;
            });
          return true;
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }

  .right-menu {
    float: right;
    height: 100%;
    &:focus {
      outline: none;
    }
    .right-menu-item {
      display: inline-block;
      margin: 0 8px;
    }
    .userinfo-container {
      height: 50px;
      margin-right: 30px;
      .username-wrapper {
        cursor: pointer;
        font-weight: normal;
        color: #303133;
        display: flex;
        align-items: center;
        .el-icon-caret-bottom {
          position: absolute;
          right: -20px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
